import {
  APP_INITIALIZER,
  ApplicationConfig,
  Injector,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import {
  ExtraOptions,
  InMemoryScrollingFeature,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { deviceInterceptor } from './interceptors/device.interceptor';
// import * as Sentry from "@sentry/angular-ivy";
import { AngularSvgIconModule } from 'angular-svg-icon';
import { provideAnimations } from '@angular/platform-browser/animations';
// import {  provideServiceWorker } from '@angular/service-worker';
import {
  APP_BASE_HREF,
  IMAGE_LOADER,
  ImageLoaderConfig,
} from '@angular/common';
import { EnvironmentService } from './environment.service';
import { appInitializer, baseHrefFactory } from './app-initializer';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import {
  provideGoogleAnalytics,
  provideGoogleAnalyticsRouter,
} from '@hakimio/ngx-google-analytics';

const scrollConfig: ExtraOptions = {
  // scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 32],
  initialNavigation: 'enabledBlocking',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      inMemoryScrollingFeature,
      withComponentInputBinding()
    ),
    provideClientHydration(),
    provideHttpClient(withInterceptors([deviceInterceptor])),
    importProvidersFrom(AngularSvgIconModule.forRoot()),
    provideAnimations(),
    provideGoogleAnalytics('G-P78KKN0Q6F'),
    provideGoogleAnalyticsRouter(),
    provideEnvironmentNgxMask(),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [Injector],
      multi: true,
    },
    { provide: APP_BASE_HREF, useFactory: baseHrefFactory },
    {
      provide: IMAGE_LOADER,
      deps: [EnvironmentService],
      useFactory: (environmentService: EnvironmentService) => {
        return (config: ImageLoaderConfig): string => {
          const { src, width } = config;

          // Return empty string if src is null or undefined
          if (!src) {
            console.warn('Image source is null or undefined:', config);
            return '';
          }

          // if pulling from local server assets, or fully qualified url just leave it alone
          if (src.indexOf('assets') > -1 || src.indexOf('http') > -1) {
            return src;
          }

          let widthOrFallback = width;
          if (!widthOrFallback) {
            widthOrFallback = 420;
          }

          const finalUrl = `${environmentService.cdnUrl}/images/resize/${src}${
            widthOrFallback ? '?width=' + widthOrFallback : ''
          }`;
          return finalUrl;
        };
      },
    },
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000'
    // })
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler(),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router]
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {},
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // }
  ],
};